import { render, staticRenderFns } from "./DuelsFilterCount.vue?vue&type=template&id=802931b0&scoped=true"
import script from "./DuelsFilterCount.vue?vue&type=script&lang=js"
export * from "./DuelsFilterCount.vue?vue&type=script&lang=js"
import style0 from "./DuelsFilterCount.vue?vue&type=style&index=0&id=802931b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802931b0",
  null
  
)

export default component.exports